<ng-container *ngIf="vm$ | async as vm">

  <div class="punt-zitting-row">
    {{vm.agendapunt.SoortZitting}} op {{vm.agendapunt.DatumZitting | date}}
  </div>

  <div class="punt-buttons-row">
    <button type="button" role="link" class="btn btn-default puntbuttons-first" *ngIf="appService.routing.backHistoryItem; else buttonZitting"
      (click)="appService.routing.navigateBack()">{{appService.routing.backHistoryItem.title}}</button>
    <ng-template #buttonZitting>
      <button type="button" role="link" class="btn btn default puntbuttons-first" [routerLink]="['/detailzitting',vm.agendapunt.ZittingId]">Naar de zitting</button>
    </ng-template>
    <div class="puntbuttons-right">
      <button type="button" role="link" (click)="puntNavigationSubj.next(-1)" class="btn btn-default puntbuttons-rest">
        <i class="icon-arrow_left"></i> Vorige agendapunt</button>
      <button type="button" role="link" (click)="puntNavigationSubj.next(+1)" class="btn btn-default puntbuttons-rest">Volgend agendapunt
        <i class="icon-arrow_right"></i>
      </button>
    </div>
  </div>

  <div class="punt-titel-row">
    <h1 class="punttitel-text head1">{{vm.agendapunt.Volgnummer}} {{vm.agendapunt.Titel}}</h1>
    <button type="button" title="Bladwijzer instellen" role="switch" [attr.aria-checked]="vm.agendapunt.BladwijzerId" class="punttitel-bladwijzer btn-icon"  (click)="toggleBookmarkSubj.next(vm.agendapunt)"
      [ngClass]="vm.agendapunt.BladwijzerId ? 'icon-star-filled': 'icon-star'"></button>
  </div>

  <div class="punt-dienst-row">
    {{vm.agendapunt.Dienst}}
  </div>

  <div class="punt-subpunten-row" *ngIf="vm.detail.Subpunten.length">
    <h2 class="head3" *ngFor="let subpunt of vm.detail.Subpunten trackBy:getSubpuntId">{{subpunt.Volgnummer}} {{subpunt.Titel}}</h2>
  </div>

  <div class="punt-documenten-row">
    <div class="punt-documenten-rowiefixwrap">
      <div *ngFor="let document of vm.detail.Documenten trackBy:getDocumentAgendapuntId"
        class="punt-documenten-document c2-clickable" tabindex="0" role="link" (keydown.enter)="navigateToDocument(document)" (click)="navigateToDocument(document)">
        <i class="icon-file"></i> {{document.Titel}}
      </div>
    </div>
  </div>

  <div class="punt__standpuntrow" *ngIf="vm.agendapunt.AlgemeenStandpuntWeergeven">
    <h2 class="head2">Algemeen standpunt : {{vm.agendapunt.BesprekenOmschrijving}}</h2>
    <button aria-label="Mijn standpunt bepalen" *ngIf="vm.agendapunt.StandpuntToegelaten && vm.agendapunt.HasCurrentUserStemrecht"
      (click)="bepaalStandpuntSubj.next(vm.agendapunt)" type="button" class="btn btn-primary button__mijnstandpunt">Mijn
      standpunt</button>
  </div>

  <div class="punt-gekoppelde-row" *ngIf="vm.detail.GekoppeldePunten.length">
    <h3 class="head2">Gekoppelde punten</h3>
    <div *ngFor="let gekoppeld of vm.detail.GekoppeldePunten trackBy:getGekoppeldPuntId" class="c2-clickable"
      (click)="navigateToRelatedPunt(gekoppeld)">
      <i class="icon-link"></i>{{gekoppeld.Titel}}
    </div>
  </div>

  <div class="punt__dossiers" *ngIf="vm.detail.Dossiers.length">
    <h2 class="head2">Gekoppelde dossiers</h2>
    <div *ngFor="let dossier of vm.detail.Dossiers trackBy:getDossierId">
      <a class="c2-clickable" (click)="navigateToDossier(dossier)">
        <i class="icon-external-link"></i> {{dossier.SoortDossier}} ({{dossier.DossierId}})</a>
    </div>
  </div>

  <div class="punt-notities-row" id="notities">
    <h2 class="head2">Notities</h2>
    <div class="puntnotities-itemrow" *ngFor="let notitie of vm.detail.Notities trackBy:getNotitieId">
      <i aria-hidden="true" class="icon-notities-dots"></i>
      <div class="puntnotities-inhoud-col">
        <strong>{{notitie.PersoonNaam}}</strong>
        <span class="padleft">{{notitie.DatumUpdate | date}}</span>
        <pre class="wrap">{{notitie.Inhoud}}</pre>
      </div>
      <div class="puntnotities-buttons-col">

        <button *ngIf="notitie.Persoonlijk" (click)="navigateToWijzigNotitie(vm.agendapunt,notitie)" aria-label="Wijzig notitie" type="button" class="btn-icon icon-pencil" ></button>
        <button *ngIf="notitie.Persoonlijk" (click)="verwijderNotitieSubj.next(notitie)" aria-label="Verwijder notitie" type="button" class="btn-icon icon-close" ></button>

        <span role="img" [attr.aria-label]="'Aantal personen : '+notitie.AantalPersonen"  class="puntnotities-aantal">{{notitie.AantalPersonen}}</span>
        <i aria-hidden="true" class="icon-user"></i>

        <button (click)="navigateToReageerNotitie(vm.agendapunt,notitie)" type="button" aria-label="Reageer op notitie" class="btn-icon icon-reply"></button>

      </div>
    </div>
  </div>
  <div class="punt-notities-button-row">
    <button (click)="navigateToNotitieToevoegen(vm.agendapunt)" class="btn btn-primary">Notitie toevoegen</button>
  </div>

  <app-bepaal-standpunt *ngIf="vm.standpunten" (closeStandpunt)="closeStandpuntSubj.next(vm)"
    [zittingId]="vm.agendapunt.ZittingId" [standpunten]="vm.standpunten"></app-bepaal-standpunt>

  <div class="punt_media_row" *ngIf="vm.detail.StreamingLink!=''">
    <h2 class="head2">Media : <i class="fa fa-video-camera c2-clickable" aria-label="Open audio/video fragment" (click)="activateMediaSubj.next(true)"></i></h2>
    <div *ngIf="vm.mediaActive" class="punt_media">
      <div class="punt_media_header">
        <h3 class="punt_media_title head2">{{vm.agendapunt.Volgnummer}} {{vm.agendapunt.Titel}}</h3>
        <!-- <i class="icon-close c2-clickable punt_media_close" (click)="activateMediaSubj.next(false)"></i> -->
        <button class="btn-icon icon-close punt_media_close" aria-label="Sluit audio/video fragment"  (click)="activateMediaSubj.next(false)"></button>
      </div>
      <iframe [src]="vm.streamingLink" class="punt_media_media"></iframe>
    </div>
  </div>

</ng-container>

